import { render, staticRenderFns } from "./lamsRegLegalLitigationProcess.vue?vue&type=template&id=fefbe278&scoped=true&"
import script from "./lamsRegLegalLitigationProcess.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalLitigationProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefbe278",
  null
  
)

export default component.exports